import { NavLink, useParams } from 'react-router-dom';
import { MainHeader } from '.';
import { useEffect, useState } from 'react';
import { useTree } from '../../../Context/useTree';
import { useThemeLoader } from '../../../Helpers/useThemeLoader';
import LoadingSpinner from '../Shared/LoadingSpinner';
import LocationNotFound from './LocationNotFound';


let MenuCatigoriesMain = () => {

    const { location } = useParams();
    const { isLoading, error, fetchTree } = useTree();
    const [menuOptions, setMenuOptions] = useState([]);
    const [hasLoadedMenuData, setHasLoadedMenuData] = useState(false);
    const { loading: themeLoading, error: themeError } = useThemeLoader(location);

    useEffect(() => {
        setHasLoadedMenuData(false);
        setMenuOptions([]);

        fetchTree(location)
            .then(data => {
                setMenuOptions(data?.menus || []);
                setHasLoadedMenuData(true);
            })
            .catch((error) => {
                console.error("Error loading menu tree:", error);
                setMenuOptions([]);
                setHasLoadedMenuData(false);
            });
    }, [location, fetchTree])


    const setCatigories = () => {
        console.log("in set catigories");
        return menuOptions.map((item) => {
            // Check if this item has a menuActionTargetGUID (cart request action)
            if (item.menuActionTargetGUID) {
                return (
                    <div className="menu-catigory-wrapper" key={item.menuId}>
                        {item.menuButtonImageUrl ? (
                            <NavLink className='nav-link' to={`/v2/${location}/CartRequest`}>
                                <img className="menu-catigory-images" 
                                    src={item.menuButtonImageUrl}
                                    alt="page text" />
                            </NavLink>
                        ) : (
                            <div className="menu-catigory-placeholder">
                                <NavLink className='nav-link' to={`/v2/${location}/CartRequest`}>
                                    <h2 className="menu-catigory-placeholder-text">{item.menuName}</h2>
                                </NavLink>
                            </div>
                        )}
                    </div>
                );
            }

            // Default behavior - navigate to menu
            return (
                <div className="menu-catigory-wrapper" key={item.menuId}>
                   { item.menuButtonImageUrl ?
                    <NavLink className='nav-link' to={`/v2/${location}/${item.menuId}`}>
                        <img className="menu-catigory-images" 
                        src={item.menuButtonImageUrl}
                         alt="page text" />
                    </NavLink>
                    :
                    <div className="menu-catigory-placeholder">
                        <NavLink className='nav-link ' to={`/v2/${location}/${item.menuId}`}>
                        <h2 className="menu-catigory-placeholder-text">{item.menuName}</h2>
                        </NavLink>
                    </div>
                
                }
                </div>
            )
        }
        )
    }

    if (themeError && !themeLoading) {
        return <LocationNotFound locationId={location} />;
    }

    if (error) {
        return <LocationNotFound locationId={location} />;
    }

    if (isLoading || themeLoading || !hasLoadedMenuData) {
        return (
            <div>
                <MainHeader turnOffBackBtn={true}/>
                <LoadingSpinner />
            </div>
        );
    }

    return (
        <div>
            <MainHeader turnOffBackBtn={true}/>
            <div>
                <h5 className="get-started-text">Please click a category to get started!</h5>
                <div className="body catigory-font-color">
                    {setCatigories()}
                </div>
            </div>
        </div>
    );

}

export default MenuCatigoriesMain;